module.exports = __webpack_public_path__ + "static/media/Pool.923ead70.jpg";